import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function CaseReviewSuccess() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const pending = params.get("pending") === "1";

  return (
    <div data-testid="case-review-success-page" className="container-x py-32">
      <div className="max-w-3xl">
        {pending ? (
          <>
            <AlertCircle size={40} className="text-[#C2A679]" strokeWidth={1.5} />
            <h1 className="font-display text-5xl mt-6 text-[#0F172A] leading-tight">
              Submission received.
              <br /><span className="italic text-[#C2A679]">Payment link coming.</span>
            </h1>
            <p className="mt-8 text-lg text-[#4A4D50] leading-relaxed">
              Your case review has been recorded. Our LawPay payment page is being configured — you will
              receive a secure payment link from our office within one business day.
            </p>
          </>
        ) : (
          <>
            <CheckCircle2 size={40} className="text-[#1A3626]" strokeWidth={1.5} />
            <h1 className="font-display text-5xl mt-6 text-[#0F172A] leading-tight">
              Thank you.
              <br /><span className="italic text-[#C2A679]">Your case review has begun.</span>
            </h1>
            <p className="mt-8 text-lg text-[#4A4D50] leading-relaxed">
              We've received your submission and payment. A senior attorney will review the file and
              respond within 5 business days at the email you provided.
            </p>
          </>
        )}
        {ref && (
          <div className="mt-10 font-mono-plex text-xs text-[#4A4D50]">
            Reference: <span className="text-[#0F172A]">{ref}</span>
          </div>
        )}
        <div className="mt-16 flex flex-wrap gap-4">
          <Link to="/" data-testid="success-home" className="btn-secondary">Return home</Link>
          <Link to="/success-stories" data-testid="success-stories" className="btn-primary">See past results</Link>
        </div>
      </div>
    </div>
  );
}
